export default __webpack_public_path__ + "static/media/7ba98337-2ff1-4864-bd42-77106600dbdd.8173f7c1.jpg";